import { DoorSlidingLockIcon } from './DoorSlidingLockIcon';

/**
 * author: Michael Irigoyen
 * id 933F6908-12B7-4448-9A83-1FAD909ECC53
 * name door-sliding-lock
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door-sliding-lock.svg
 * tags
 * - Home Automation 
 * - Lock 
 */
export const FrenchDoorLockIcon = DoorSlidingLockIcon;
export default FrenchDoorLockIcon